export function isValidAddressLine2(addressLine2) {
  return addressLine2 ? (addressLine2.length > 0 || "Address Line 2 is required") : "Address Line 2 is required"
}

export const rules = [isValidAddressLine2]
